import React from "react";
import {

  Tabs, Layout
} from "antd";
import Client from "../User/Client/Client";
import ClientPlans from "./ClientPlans";
import AgencyPlans from "./AgencyPlans";
const { Content } = Layout;

const { TabPane } = Tabs;

class MyPlans extends React.Component {

  constructor(props) {

    super(props);
    this.state =
    {
      defaultActiveKey: "1"

    }
  }

  render() {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    return (
      role === "carrier" ?
        <Client {...this.props} isprofile={false} userPermandMasters={this.props.userPermandMasters} /> :
        role === "broker" ?
          <Content>
            <div className="mi_main_div">
              <ClientPlans title="My Plans"  {...this.props} userPermandMasters={this.props.userPermandMasters} /></div></Content> :

          <Content>

            <div className="mi_main_div" style={{ paddingLeft: "38px" }}>
              <Tabs style={{ padding: '0px 10px' }} defaultActiveKey={this.state.defaultActiveKey}>

                <TabPane tab={<span >Carrier Plans</span>} key="1" >
                  <div  >
                    <ClientPlans {...this.props} title="Carrier Plans" userPermandMasters={this.props.userPermandMasters} />
                  </div>
                </TabPane>
                <TabPane tab={<span>Our Plans</span>} key="2">
                  <div  >
                    <AgencyPlans {...this.props} title="Carrier Plans" userPermandMasters={this.props.userPermandMasters} />
                  </div>
                </TabPane>
              </Tabs></div></Content>


    );
  }
}
export default MyPlans;
